module.exports = __webpack_public_path__ + "img/call.bd04135c.webp";